import React from 'react'
import * as UI from '@brewlogix/blx-ui'
import { Location } from 'src/types/schema/graphql'
import { mapStore } from 'src/features/Map/state/mapStore'
import { guidGenerator } from 'src/features/Map/utils/functions'
import { parseStateLabel } from 'src/features/BrewDetail/util/helpers'
import { FavoriteType } from 'src/features/favorites/types/enums/FavoriteType'
import LegacyFavoritesButton from 'src/features/favorites/components/LegacyFavoritesButton'

interface ICardActions {
    location: Location
    type: 'result' | 'popup'
    showFavoriteAction?: boolean
    showRouteAction?: boolean
}

const CardActions: React.FC<ICardActions> = ({ location, showFavoriteAction, showRouteAction }) => {
    const setActiveTab = mapStore((state) => state.setActiveTab)
    const setDirectionsCoordinates = mapStore((state) => state.setDirectionsCoordinates)
    const handleAddRouteClick = (e: React.ChangeEvent<HTMLButtonElement>) => {
        e.stopPropagation()
        setActiveTab('routes')
        const parsedAddress = location?.address
            ? [
                  location?.address?.street,
                  location?.address?.city,
                  parseStateLabel(location?.address?.state),
                  location?.address?.postalCode,
              ]
                  .filter((item) => item && item !== '')
                  .join(', ')
            : ''

        setDirectionsCoordinates({
            directionCoordinates: {
                lon: location?.address?.geo?.lon,
                lat: location?.address?.geo?.lat,
                title: location?.brand?.displayTitle || location?.brand?.title,
                placeName: parsedAddress,
                location: location,
            },
            action: 'add',
        })
    }
    return (
        <div className='-mr-2 -mt-2 flex flex-col items-center'>
            {showFavoriteAction && (
                <LegacyFavoritesButton
                    heartSize='md'
                    type={FavoriteType.Location}
                    ariaLabel={`Add ${location?.title} to Your Favorites`}
                    item={location}
                />
            )}
            {showRouteAction && (
                <UI.Button
                    hiddenText
                    theme='link'
                    icon='BeerRoutes'
                    size='md'
                    customClasses='p-0 text-dark '
                    aria-label={`Add ${
                        location?.brand?.displayTitle || location?.brand?.title
                    } to Your Route`}
                    onClick={(e: React.ChangeEvent<HTMLButtonElement>) => handleAddRouteClick(e)}
                />
            )}
        </div>
    )
}
export default CardActions
